<template lang="html">
  <div id="payment-notification" class="row">
    <div v-if="loader" class="loader"></div>
    <div class="col-lg-3"></div>
    <div class="col-lg-9 payment-notification-container">
      <div class="row">
        <h3>{{message}}</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      translation: null,
      loader: false,
      status: false,
      message: ''
    }
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    this.status = this.$route.params.status;
    console.log(this.status);
    if (this.status == 'true') {
      this.message = this.translation.payment.successPayment;
    }else{
      this.message = this.translation.payment.errorPayment;
    }
  },
}
</script>

<style lang="css" scoped>
#payment-notification{
  background-image: url('../assets/img/backgrounds/background-after-login.jpg');
  background-repeat:no-repeat;
  max-width:inherit;
  max-height: 100%;
  background-position: center;
  background-size: cover;
}
#payment-notification .payment-notification-container{
  margin-top: 6em;
  height: 100vh;
}
#payment-notification .payment-notification-container h3 {
  color: #3057B0;
}
</style>
